import { render } from "./ChangeLogComplain.vue?vue&type=template&id=1cf88b5b"
import script from "./ChangeLogComplain.vue?vue&type=script&lang=ts"
export * from "./ChangeLogComplain.vue?vue&type=script&lang=ts"
script.render = render

export default script